import { Points_Of_Interest } from '@/types/cate-graphql-generated-types'

export type Poi = {
  coordinates: {
    lat: number
    lon: number
  }
  distance: number
  name: string
  poiType: string
}

export const buildPoiFrom = (pois: Points_Of_Interest[]): Poi[] => {
  return pois.map((poi) => ({
    coordinates: poi.coordinates,
    distance: poi.distance,
    name: poi.name,
    poiType: poi.poiType,
  }))
}

export type MapPoi = Poi & {
  slug: string
}

export type PoiCategory = 'TRANSPORT' | 'SCHOOL' | 'SHOP'

export enum PoiType {
  BusStop = 'BUS_STOP',
  School = 'SCHOOL',
  Shop = 'SHOP',
  SubwayStation = 'SUBWAY_STATION',
  TrainStation = 'TRAIN_STATION',
  TramStop = 'TRAM_STOP',
}
